import { createEntityProfile, entityProfile, updateProfileSection } from './types';

export const requestCreateEntityProfile = (entityId, promise) => ({
  type: createEntityProfile.request,
  entityId,
  promise,
});

export const requestCreateEntityProfileSuccess = (entityId, response) => ({
  type: createEntityProfile.success,
  entityId,
  response,
});

export const requestCreateEntityProfileFailure = (entityId, error) => ({
  type: createEntityProfile.failure,
  entityId,
  error,
});

export const requestEntityProfile = (entityId, promise) => ({
  type: entityProfile.request,
  entityId,
  promise,
});

export const requestEntityProfileSuccess = (entityId, response) => ({
  type: entityProfile.success,
  entityId,
  response,
});

export const requestEntityProfileFailure = (entityId, error) => ({
  type: entityProfile.failure,
  entityId,
  error,
});

export const requestUpdateProfileSection = (entityId, sectionId, payload, promise) => ({
  type: updateProfileSection.request,
  entityId,
  sectionId,
  payload,
  promise,
});

export const requestUpdateProfileSectionSuccess = (entityId, sectionId, response) => ({
  type: updateProfileSection.success,
  entityId,
  sectionId,
  response,
});

export const requestUpdateProfileSectionFailure = (entityId, sectionId, error) => ({
  type: updateProfileSection.failure,
  entityId,
  sectionId,
  error,
});
